import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { getSocket } from 'utils/socketManager';
import { getToken } from 'utils/crypto';
import { taskActions } from 'store';

const TASK_EVENTS = ['TASK_CREATED', 'TASK_UPDATED', 'TASK_STATUS_CHANGED', 'TASK_ASSIGNED', 'TASK_DELETED', 'TASK_COMMENT_CREATED'];

/**
 * Registers socket listener for task-related global events.
 * Silently refreshes the task list when another user modifies tasks.
 */
export const useTaskSocket = (params) => {
    const dispatch = useDispatch();
    const handlersRef = useRef({});

    useEffect(() => {
        const token = getToken();
        if (!token) return;

        const socket = getSocket(token);
        if (!socket) return;

        handlersRef.current.onGlobalEvent = (data) => {
            if (data?.evenType && TASK_EVENTS.includes(data.evenType)) {
                dispatch(taskActions.getTasks(params, 'noLoad'));
            }
        };

        socket.on('SEND_EVENTS_GLOBAL', handlersRef.current.onGlobalEvent);

        return () => {
            socket.off('SEND_EVENTS_GLOBAL', handlersRef.current.onGlobalEvent);
        };
    }, [params]);
};

/**
 * Listens for task detail updates — refreshes a specific task when it's modified.
 */
export const useTaskDetailSocket = (taskId) => {
    const dispatch = useDispatch();
    const handlersRef = useRef({});

    useEffect(() => {
        if (!taskId) return;

        const token = getToken();
        if (!token) return;

        const socket = getSocket(token);
        if (!socket) return;

        handlersRef.current.onGlobalEvent = (data) => {
            if (data?.evenType && TASK_EVENTS.includes(data.evenType)) {
                const eventTaskId = data?.data?.taskId;
                const eventTaskIds = data?.data?.taskIds;
                if (eventTaskId === taskId || (eventTaskIds && eventTaskIds.includes(taskId))) {
                    dispatch(taskActions.getTaskById(taskId));
                }
            }
        };

        socket.on('SEND_EVENTS_GLOBAL', handlersRef.current.onGlobalEvent);

        return () => {
            socket.off('SEND_EVENTS_GLOBAL', handlersRef.current.onGlobalEvent);
        };
    }, [taskId]);
};
